/*
* 文書の内容確認（管理画面専用）
*/
import client from '@js/modules/httpClient/index.js';

export default class DocumentCheck {
  constructor() {
    this.$checkConsents = document.querySelectorAll('[data-target="checkConsent"]');
  }

  multipleAttachEvent() {
    const arr = Object.values(this.$checkConsents);

    Array.prototype.forEach.call( this.$checkConsents, $item => {
      const target_id = $item.getAttribute('data-id');
      const target_buttons = Object.values(document.querySelectorAll(`[data-target="${target_id}-button"]`));

      window.addEventListener('pageshow', () => {
        confirmInput();
      });

      $item.addEventListener('change', () => {
        confirmInput();
        approvalable();
      });

      const confirmInput = () => {
        const value = arr.filter((e)=>{
          return e.getAttribute('data-id') === target_id;
        } ).every(function(result){
          return result.checked;
        });

        if ( value === true ) {
          target_buttons.map($button => {
            $button.classList.add('is-active');
          });
        } else {
          target_buttons.map($button => {
            $button.classList.remove('is-active');
          });
        }
      };

      const dataPost = async (id, name, checked, url) => {
        try {
          await client.post(`/customers/${url}/approval/`, {
            approvalable_id: id,
            approvalable_type: name,
            checked: checked
          });
        } catch(e) {
          console.log(e);
        }
      };

      const  approvalable = () => {
        const approvalableId = $item.getAttribute('data-approvalableId');
        const approvalableName = $item.getAttribute('data-approvalableType');
        const customerId = $item.getAttribute('data-customerId');

        if(approvalableId) {
          dataPost(approvalableId, approvalableName, $item.checked, customerId);
        } else {
          return;
        }
      };
    });
  }
}
